// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610080105/js/" + chunkId + "." + {"44":"fc3fa52d","225":"74adbdd2","481":"b6509196","486":"641b3b84","770":"d65ef216"}[chunkId] + ".0.48129359251776993.chunk.js";
};